import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdAccountBalance,
  MdArrowBackIos,
  MdAutoAwesome,
  MdCalendarToday,
  MdCampaign,
  MdChat,
  MdChatBubbleOutline,
  MdClose,
  MdFavoriteBorder,
  MdGroup,
  MdGroups,
  MdMail,
  MdMailOutline,
  MdOutlineCampaign,
  MdPerson,
  MdPersonAdd,
  MdPersonOutline,
  MdSearch,
  MdTaskAlt,
} from "react-icons/md";

import "../styles/App.css";
import { useLocation, useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import { isEmpty } from "../functions/isEmpty";
import { useLanguage } from "../contexts/LanguageContext";

export default function Topnav({ isMobile, user, phase, resetChat, reason }) {
  let navigate = useNavigate();
  const location = useLocation();
  const { language, switchLanguage } = useLanguage();

  return (
    <div className="app_topnav">
      <div className="app_topnav_left" onClick={() => navigate("/")}>
        Dein stoischer Freund
      </div>

      <div className="app_topnav_link">Erklärung: {reason}</div>

      <div className="app_topnav_right">
        <div className="app_topnav_right_link">Aktuelle Phase: {phase}</div>
        <div className="app_topnav_right_navlink" onClick={() => resetChat()}>
          Chat und Phasen zurücksetzen
        </div>
      </div>
    </div>
  );
}

const PersonIcon = styled(MdPersonAdd)`
  font-size: 33px;
  color: #717171;
`;

const PersonIconActive = styled(MdPersonAdd)`
  font-size: 33px;
  color: #950178;
`;

const GroupIcon = styled(MdGroups)`
  font-size: 36px;
  color: #717171;
`;

const GroupIconActive = styled(MdGroups)`
  font-size: 36px;
  color: #950178;
`;

const SearchIcon = styled(MdSearch)`
  font-size: 32px;
  color: #717171;
  margin-bottom: -2px;
`;

const SearchIconActive = styled(MdSearch)`
  font-size: 32px;
  color: #ff29a7;
  margin-bottom: -2px;
`;

const ChatsIcon = styled(MdChatBubbleOutline)`
  font-size: 26px;
  color: #717171;
`;

const ChatsIconActive = styled(MdChatBubbleOutline)`
  font-size: 26px;
  color: #2d81e0;
`;

const TasksIcon = styled(MdTaskAlt)`
  font-size: 26px;
  color: #717171;
`;

const TaskIconActive = styled(MdTaskAlt)`
  font-size: 26px;
  color: #2d81e0;
`;

const AutoIcon = styled(MdAutoAwesome)`
  font-size: 26px;
  color: #717171;
`;

const AutoIconActive = styled(MdAutoAwesome)`
  font-size: 26px;
  color: #2d81e0;
`;

const MailIcon = styled(MdMailOutline)`
  font-size: 31px;
  color: #717171;
  margin-bottom: -2px;
`;

const MailIconActive = styled(MdMail)`
  font-size: 31px;
  color: #ff29a7;
  margin-bottom: -2px;
`;

const BankIcon = styled(MdAccountBalance)`
  font-size: 27px;
  color: #717171;
  margin-bottom: -1px;
`;

const BankIconActive = styled(MdAccountBalance)`
  font-size: 27px;
  color: #ff29a7;
  margin-bottom: -1px;
`;

const CampaignIcon = styled(MdCampaign)`
  font-size: 32px;
  color: #717171;
  margin-bottom: -1px;
`;

const CampaingIconActive = styled(MdCampaign)`
  font-size: 32px;
  color: #ff29a7;
  margin-bottom: -1px;
`;

const CalendarIcon = styled(MdCalendarToday)`
  font-size: 25px;
  color: #717171;
  margin-bottom: 2px;
`;

const CalendarIconActive = styled(MdCalendarToday)`
  font-size: 25px;
  color: #ff29a7;
  margin-bottom: 2px;
`;
